import { DatePicker, type FormConfig, type FormFieldConfig } from '@eo/shared';

import type { BudgetValues, SupplementValues } from '../types';

export const budgetFormConfig: FormConfig<BudgetValues> = {
  fields: [
    { id: 'fixedHours', label: 'Fixed hours', type: 'number', colSpan: 1 },
    { id: 'variableHours', label: 'Variable hours', type: 'number', colSpan: 1 },
  ],
};

// The window fields keep the calendar the rest of the app uses; FormConfig's
// built-in types are text/number/textarea/select only.
function dateField(
  id: 'startDate' | 'endDate',
  label: string,
): FormFieldConfig<SupplementValues, void> {
  return {
    id,
    label,
    required: true,
    colSpan: 1,
    render: (form) => (
      <DatePicker
        value={form.values[id]}
        onChange={(value) => form.set(id, value)}
        ariaLabel={label}
      />
    ),
  };
}

export const supplementFormConfig: FormConfig<SupplementValues> = {
  fields: [
    {
      id: 'bucket',
      label: 'Bucket',
      type: 'select',
      colSpan: 1,
      options: [
        { value: 'variable', label: 'Variable' },
        { value: 'fixed', label: 'Fixed' },
      ],
    },
    {
      id: 'kind',
      label: 'Kind',
      type: 'select',
      colSpan: 1,
      options: [
        { value: 'supplement', label: 'Supplement' },
        { value: 'onboarding', label: 'Onboarding' },
      ],
    },
    { id: 'hours', label: 'Hours', type: 'number', required: true, colSpan: 1 },
    dateField('startDate', 'Start date'),
    dateField('endDate', 'End date'),
    { id: 'notes', label: 'Notes', type: 'textarea', rows: 2 },
  ],
};
